import { createSelector } from 'reselect'

const getMyAccountSchoolsData = state => state.myAccount.schools

const multipleSchoolsSelector = createSelector(
	[getMyAccountSchoolsData], schoolsData => {
		const privateLibraryIds = schoolsData.map(function(school) {
			return school.privateLibraryId
		})

		return 	privateLibraryIds
	}
)

export default multipleSchoolsSelector
